export default __webpack_public_path__ + "static/media/fortune-bg-large.d63e23ba.jpg";